export default class MessageBox {
    constructor($ionicPopup, ionicToast) {
        this.ionicToast = ionicToast;
        this.$ionicPopup = $ionicPopup;
    }

    /**
     * @param  {string} title title which is displayed in the message box
     * @param  {string} content message to be displayed in the message box
     * @return {void}
     */
    show(title, content) {
        this.$ionicPopup.alert({
            title: `<b>${this.toProperCase(title)}</b>`,
            template: content,
            okType: 'button-picton-blue'
        });
    }

    /**
     * Show successful save message box
     * @param  {string} entity The name of the entity in capital case. eg CAMAIGN, CAMPAIGN_CONTACT
     * @param  {string} action The action during which the message is to be displayed. eg SAVE, EDIT, DELETE
     * @return {void}
     */
    showSuccessMessage(entity, action) {
        const messageTemplate = `{{"${entity}_${action}_SUCCESS_MSG" | translate}}`;
        this.$ionicPopup.alert({
            title: `<b>${this.toProperCase(action)} successful</b>`,
            template: messageTemplate,
            okType: 'button-picton-blue'
        });
    }

    /**
     * Show successful fail message box
     * @param  {string} entity The name of the entity in capital case. eg CAMAIGN, CAMPAIGN_CONTACT
     * @param  {string} action The action during which the message is to be displayed. eg SAVE, EDIT, DELETE
     * @return {void}
     */
    showFailMessage(entity, action, error) {
        const messageTemplate = `{{"${entity}_${action}_FAIL_MSG" | translate}}`;
        this.$ionicPopup.alert({
            title: `<b>${this.toProperCase(action)} failed</b>`,
            template: messageTemplate,
            okType: 'button-picton-blue'
        });
    }

    showToaster(message, position, stick) {
        this.ionicToast.show(message, position, stick, 2000);
    }

    hideToaster() {
        this.ionicToast.hide();
    };

    toProperCase(text) {
        return text.toLowerCase().replace(/(^[a-z]| [a-z]|-[a-z])/g,
            function ($1) {
                return $1.toUpperCase();
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/services/messageBox.js
 **/